import React from 'react';
import clsx from 'clsx';
import InputField from '../../Forms/Input/InputField';
import { ICustomerForm } from '../../../types/customer/customerInterfaces';
import { useCustomer } from '../../../hooks/useCustomer';

interface Props {
  form: ICustomerForm;
  updateField: (field: keyof ICustomerForm, value: any) => void;
  isSubmitting?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
}

const CustomerGeneralForm: React.FC<Props> = ({
  form,
  updateField,
  isSubmitting = false,
  onCancel,
  onSubmit,
}) => {
  const { errors } = useCustomer();

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      {/* ÚNICO CAMPO REQUERIDO */}
      <InputField
        label="Nombre"
        name="name"
        value={form.name}
        onChange={(e) => updateField('name', e.target.value)}
        type="text"
        placeholder="General"
        iconKey="user"
        error={errors?.name}
      />

      {(onCancel || onSubmit) && (
        <div className="mt-6 flex gap-4 md:col-span-2">
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 rounded bg-[#DC3545] px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
            >
              Cancelar
            </button>
          )}
          {onSubmit && (
            <button
              type="button"
              disabled={isSubmitting}
              onClick={onSubmit}
              className={clsx(
                'flex-1 rounded px-4.5 py-2.5 font-medium text-white',
                isSubmitting
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-primary hover:bg-opacity-90'
              )}
            >
              {isSubmitting
                ? form.id
                  ? 'Actualizando...'
                  : 'Guardando...'
                : form.id
                ? 'Actualizar Cliente'
                : 'Registrar Cliente'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerGeneralForm;
